import { PatientGender } from '@silbo/core';
import { EmojiType } from '@silbo/ui';

export const getPatientEmojiIcon = (gender: PatientGender, age: number, outlined?: boolean): EmojiType => {
  switch (gender) {
    case 'MALE':
      return age < 18 ? `boy${outlined ? 'Outlined' : ''}` : `man${outlined ? 'Outlined' : ''}`;

    case 'FEMALE':
      return age < 18 ? `girl${outlined ? 'Outlined' : ''}` : `woman${outlined ? 'Outlined' : ''}`;

    case 'UNKNOWN':
    default:
      return age < 18 ? `kid${outlined ? 'Outlined' : ''}` : `adult${outlined ? 'Outlined' : ''}`;
  }
};
